//  --- All Micro-services endpoint configs

import { getIsDemoHost } from "utilities/demo_utilities";

const replaceDomainWithApiGateway = (originalUrl, apiGateWayDomain) => {
  try {
    const orginalURL = new URL(originalUrl);
    const apiGateWay = new URL(apiGateWayDomain);
    const originalHost = `${orginalURL?.protocol}//${orginalURL.hostname}`;
    const apiGateWayHost = `${apiGateWay?.protocol}//${apiGateWay.hostname}${apiGateWay?.port ? ':' + apiGateWay.port : ''}`;
    const finalURL = originalUrl.replace(originalHost, apiGateWayHost);
    return finalURL;
  } catch (e) {
    console.log('Not an URL', originalUrl);
    return originalUrl;
  }
}

const updateServices = (originalUrl) => {
  const isDemoHost = getIsDemoHost();
  if(isDemoHost) {
    return replaceDomainWithApiGateway(originalUrl, process.env.REACT_APP_DEMO_API_GATEWAY_URL);
  }
  return originalUrl;
}

export const apiServices = {
  auth: updateServices(process.env.REACT_APP_AUTH_SERVICE_API_HOST),
  maataram: updateServices(process.env.REACT_APP_MAATARAM_SERVICE_API_HOST),
  dashboard: updateServices(process.env.REACT_APP_DASHBOARD_SERVICE_API_HOST),
  chart: updateServices(process.env.REACT_APP_CHART_SERVICE_API_HOST),
  account: updateServices(process.env.REACT_APP_ACCOUNT_DETAILS_SERVICE_API_HOST),
  recommendations: updateServices(process.env.REACT_APP_RECOMMENDATIONS_SERVICE_API_HOST),
  insights: updateServices(process.env.REACT_APP_INSIGHTS_SERVICE_API_HOST),
  segmentation: updateServices(process.env.REACT_APP_SEGMENTATION_DETAILS_SERVICE_API_HOST),
  locale: updateServices(process.env.REACT_APP_ACCOUNT_DETAILS_SERVICE_API_HOST),
  image_upload: updateServices(process.env.REACT_APP_IMAGE_UPLOAD_SERVICE_API_HOST),
  image_cdn: updateServices(process.env.REACT_APP_IMAGES_CDN_URL),
  ci_dashboard: updateServices(process.env.REACT_APP_CI_SERVICE_API_HOST),
  template: updateServices(process.env.REACT_APP_TEMPLATE_SERVICE_API_HOST),
  inventory: updateServices(process.env.REACT_APP_INVENTORY_SERVICE_API_HOST),
  ama: updateServices(process.env.REACT_APP_AMA_API_HOST),
  sphere: updateServices(process.env.REACT_APP_SPHERE_API_HOST),
  admin_serve: updateServices(process.env.REACT_APP_ADMIN_SERVE_API_HOST),
  keyword_suggestion: updateServices(process.env.REACT_APP_KEYWORD_API_HOST),
  promotion: updateServices(process.env.REACT_APP_PROMOTION_API_HOST),
  pluginserv: updateServices(process.env.REACT_APP_PLUGIN_API_HOST),
  finance: updateServices(process.env.REACT_APP_FINANCE_SERVICE_API_HOST),
  billingServ: updateServices(process.env.REACT_APP_BILLING_SERV_API_HOST),
  order: updateServices(process.env.REACT_APP_ORDER_SERVICE_API_HOST),
  reportServer: updateServices(process.env.REACT_APP_REPORT_SERVICE_API_HOST),
  ads_management: updateServices(process.env.REACT_APP_ADSMANAGEMENT_SERVICE_API_HOST),
  seller_report: updateServices(process.env.REACT_APP_SELLER_REPORT_API_HOST),
  novu_web: updateServices(process.env.REACT_APP_NOVU_WEB_HOST),
  novu_api: updateServices(process.env.REACT_APP_NOVU_API_HOST),
  novu_web_socket: updateServices(process.env.REACT_APP_NOVU_WEB_SOCKET_HOST),
  batch: updateServices(process.env.REACT_APP_BATCH_PROCESSOR_API),
  api_server: updateServices(process.env.REACT_APP_API_SERVER_API_HOST),
  chart_builder: updateServices(process.env.REACT_APP_CHART_BUILDER_HOST),
  rca: updateServices(process.env.REACT_APP_RCA_SERVER_API_HOST),
  journal: updateServices(process.env.REACT_APP_JOURNAL_SERVICE_API_HOST),
  media_service: updateServices(process.env.REACT_APP_MEDIA_SERVICE_API_HOST),
  data_ingestion: updateServices(process.env.REACT_APP_DATA_INGESTION_HOST),
  graas_image_upload: updateServices(process.env.REACT_APP_GRAAS_IMAGE_UPLOAD_URL),
  listing_lookup: updateServices(process.env.REACT_APP_LISTING_LOOKUP_SERVER_HOST),
  customer_management: updateServices(process.env.REACT_APP_CUSTOMER_MANAGEMENT_SERVER_HOST),
  hoppr: updateServices(process.env.REACT_APP_HOPPR_SERVER_HOST),
  api_gateway: updateServices(process.env.REACT_APP_API_GATEWAY_URL),
  demoDomin: updateServices(process.env.REACT_APP_DEMO_DOMAIN),
  tcDomin: updateServices(process.env.REACT_APP_API_DOMAIN),
  hopper_ws: updateServices(process.env.REACT_APP_HOPPER_SOCKET_URL)
};